import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import MasterPromoTab from "./components/masterPromoTab";

class MasterPromo extends Component {
    contents = [
        {
            title: "CASH",
            component: <MasterPromoTab tab="cash" menuAccess={this.props.menuAccess}/>
        },
        {
            title: "KREDIT",
            component: <MasterPromoTab tab="credit" menuAccess={this.props.menuAccess}/>
        },
    ]

    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        {this.contents.map((content, index) => (
                            <Tab
                                key={content.title + index}
                                id={`btn_navigate_${content.title}`}
                            >
                                {content.title}
                            </Tab>
                        ))}
                    </TabList>
                    {this.contents.map((content, index) => (
                        <TabPanel key={content.title + index}>{content.component}</TabPanel>
                    ))}
                </Tabs>
            </Container>
        )
    }
}

export default MasterPromo;
